import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import LeagueSeasonPlayerApi from './LeagueSeasonPlayerApi';

let settings;

export default settings = {
    key: 'league/seasons/players',
    zone: 'leagues',
    path: '/league/seasons/players',
    title: "League Player",
    endpoint: LeagueSeasonPlayerApi.endpoint,
    modelName: 'LeagueSeasonPlayer',
    idKey: 'id',
    primaryKey: 'name',
    actions: ['trash'],
    indexCaps: ["viewLeagueSeasonPlayer"],
    viewCaps: ["viewLeagueSeasonPlayer"],
    createCaps: ["createLeagueSeasonPlayer"],
    updateCaps: ["updateLeagueSeasonPlayer"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: LeagueSeasonPlayerApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ["owner", "team"], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['name'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Name",
                key: "name",
                type: "text",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Position",
                key: "position",
            },
            {
                label: "City",
                key: "city"
            },
            {
                label: "IC Number",
                key: "icNumber",
            },
            {
                label: "Jersey Number",
                key: "jerseyNumber",
            },
            {
                label: "Team",
                key: "team",
                format: "ModelLink",
            },
            {
                label: "User Account",
                key: "owner",
                format: "ModelLink",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: LeagueSeasonPlayerApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: LeagueSeasonPlayerApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ["owner", "team", "season"] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        if (data && data.team && data.team.name) title = title + ", " + data.team.name;
        if (data && data.season && data.season.title) title = title + ", " + data.season.title;

        return title;

    },
    singleButtons: (routeName, params, users, fetch) => {

        const data = get(fetch, 'data');

        if (data) {

            return [
                {
                    label: "Manage Season",
                    path: "/league/seasons/" + data.seasonId + "/view",
                }
            ]

        }

        return [];

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};